module.exports = __webpack_public_path__ + "img/hero-house.f0baade5.svg";